import React from 'react'
import {
    Form,
    Input,
    Button,
    Row,
    Col,
    Divider,
    Select,
    Spin,
    Checkbox,
    Switch
} from 'antd';
import API from '../../../services/API'

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

class WarehousesForm extends React.Component {
    // eslint-disable-next-line react/state-in-constructor
    state = {
        data: {
            subsidiary_id: {
                key: '',
                label: '',
            },
        },
        subsidiaries: {
            data: [],
            loading: false,
        },
    }

    componentDidMount() {
        this.getAdditionalData();
        // To disabled submit button at the beginning.
        if (this.props.fields && this.props.fields.name) {
            // eslint-disable-next-line prefer-const
            let tmpSubsidiary = {}
            if (this.props.subsidiary) {
                tmpSubsidiary.subsidiary_id = {
                    key: this.props.subsidiary.id,
                    label: this.props.subsidiary.name,
                }
            }
            this.props.form.setFields({
                ...this.props.fields,
            });
            this.setState({
                data: {
                    ...tmpSubsidiary,
                },
            });

            // this.props.setParentState("loading", false);
            this.props.form.validateFields();
        }
        this.getSubsidiaries('');
    }

    getAdditionalData = () => {
        this.setState({
            subsidiaries: {
                data: [],
                    loading: true,
            },
        })
        API.get('/api/subsidiaries')
            .then((response) => {
                this.setState({
                    subsidiaries: {
                        data: response.data.data.map((item) => ({
                            value: item.id,
                            text: item.name,
                        })),
                        loading: false,
                    },
                })
            })
            .catch((err) => {
                console.error('error en sucursales ', error);
            });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const { getValuesForm } = this.props;
                if (getValuesForm) {
                    getValuesForm({
                        ...values,
                        ...this.state.data,
                    });
                }
            } else {
            }
        });
    }

    getResourceTypeahead = async (resource, uri, stateCallback) => {
		try {
			await this.setState({
				[resource]: {
					// eslint-disable-next-line react/no-access-state-in-setstate
					...this.state[resource],
					loading: true,
				},
			})
            const response = await API.get(uri)
			this.setState({
				[resource]: {
					data: response.data.data.map(stateCallback),
					loading: false,
				},
			})
		} catch (error) {
			this.setState({
				[resource]: {
					data: [],
					loading: false,
				},
			})
		}
    }

    getSubsidiaries = (search) => {
        this.getResourceTypeahead(
			'subsidiaries',
			`/api/subsidiaries?filter[name]=${search}`,
			(subsidiarie) => ({
				text: `${subsidiarie.name}`,
				value: subsidiarie.id,
			}),
		)
    }

    handleSelectChange = (name) => (value) => {
		this.setState({
            data: {
                // eslint-disable-next-line react/no-access-state-in-setstate
                ...this.state.data,
				[name]: value,
			},
		})
    }

    getActivated = () => {
        // this.state.data.has_inventory
    }

    getHasInventory = async () => {
        const {
            getFieldValue,
        } = this.props.form;
        const value = await getFieldValue('has_inventory');
        return !!value;
    }

    render() {
        const {
            getFieldDecorator, getFieldsError, getFieldError, isFieldTouched,
        } = this.props.form;
        // Only show error after a field is touched.
        const nameError = isFieldTouched('name') && getFieldError('name');
        const typeError = isFieldTouched('type') && getFieldError('type');
        const subsidiaryError = isFieldTouched('subsidiary') && getFieldError('subsidiary');
        // const has_inventoryError = isFieldTouched('has_inventory') && getFieldError('has_inventory');

        // const managerError = isFieldTouched('manager_id') && getFieldError('manager_id');
        return (
            <>
                <Form>
                    <Row gutter={16}>
                        <Col lg={12} md={18} sm={24}>
                            <Form.Item label="Nombre de Almacen"
                                validateStatus={nameError ? 'error' : 'success'}
                                help={nameError || ''}
                                hasFeedback
                            >
                                {getFieldDecorator('name', {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'No se puede quedar el nombre campo en blanco!',
                                        },
                                        {
                                            min: 4,
                                            message: 'El nombre es muy corto.',
                                        },
                                        {
                                            max: 250,
                                            message: 'El nombre es muy largo.',
                                        },
                                    ],
                                })(
                                    <Input
                                        placeholder="Nombre de almacen"
                                    />,
                                )}
                            </Form.Item>
                            <Form.Item label="Tipo"
                                validateStatus={typeError ? 'error' : 'success'}
                                help={typeError || ''}
                                hasFeedback
                            >
                                {getFieldDecorator('type', {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'No se puede quedar el nombre campo en blanco!',
                                        },
                                    ],
                                })(
                                    <Select placeholder="Busca una sucursal">
                                        {/* eslint-disable-next-line react/jsx-no-undef */}
                                        <Option value="main">main</Option>
                                    </Select>,
                                )}
                            </Form.Item>
                        </Col>
                        <Col lg={12}>
                            <Form.Item label="Sucursal"
                                validateStatus={subsidiaryError ? 'error' : 'success'}
                                help={subsidiaryError || ''}
                                hasFeedback
                            >
                                <Select
                                    showSearch
                                    // Aqui se selecciona el objeto keylabel
                                    labelInValue
                                    value={this.state.data.subsidiary_id}
                                    placeholder="Busca una sucursal"
                                    notFoundContent={
                                        this.state.subsidiaries
                                            .loading ? (
                                            <Spin size="small" />
                                        ) : (
                                            'No hay resultados'
                                        )
                                    }
                                    filterOption={false}
                                    optionFilterProp="children"
                                    // eslint-disable-next-line react/jsx-no-duplicate-props
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    onSearch={this.getSubsidiaries}
                                    onChange={this.handleSelectChange('subsidiary_id')}
                                    style={{ width: '100%' }}
                                >
                                    {this.state.subsidiaries.data.map((d) => (
                                            // eslint-disable-next-line react/jsx-no-undef
                                            <Option key={d.value}>
                                                {d.text}
                                            </Option>
                                        ))}
                                </Select>
                            </Form.Item>
                            <Form.Item label="Tiene inventario">
                                {getFieldDecorator('has_inventory', {
                                    rules: [
                                        {
                                            required: false,
                                            message: 'Activo',
                                        },
                                    ],
                                })(
                                    <Switch defaultChecked={this.props.fields && !!this.props.fields.has_inventory.value} />,
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <Divider />
                <Row type="flex" justify="center">
                    <Col>
                        <Button
                            type="primary"
                            size="large"
                            icon="save"
                            disabled={hasErrors(getFieldsError())}
                            onClick={this.handleSubmit}
                        >
                            Guardar
                        </Button>
                    </Col>
                </Row>
            </>
        );
    }
}

const WrappedWarehousesForm = Form.create({ name: 'WarehousesVerticalForm' })(WarehousesForm);
export default WrappedWarehousesForm;
